import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class TriggerKind extends Cloneable {
    static NONE = new TriggerKind(0, "NONE");
    static GENERIC = new TriggerKind(1, "GENERIC");
    static ITEM = new TriggerKind(2, "ITEM");
    static TALK = new TriggerKind(4, "TALK");
    static QUEST = new TriggerKind(3, "QUEST");

    static ORDER = new TriggerKind(6, "ORDER");
    static SHIP = new TriggerKind(12, "SHIP");
    static JOHAN = new TriggerKind(13, "JOHAN");

    static TRADER = new TriggerKind(11, "TRADER");
    static TUTORIAL = new TriggerKind(7, "TUTORIAL");
    static PRODUCT = new TriggerKind(8, "PRODUCT");
    static CURRENCY = new TriggerKind(9, "CURRENCY");
    static TRIGGER_GROUP = new TriggerKind(10, "TRIGGER_GROUP");
    static ITEM_GROUP = new TriggerKind(5, "ITEM-GROUP");

    static SMART_OFFER = new TriggerKind(14, "SMART-OFFER");

    static _values = [
        this.GENERIC,
        this.ITEM,
        this.TALK,
        this.QUEST,
        this.ORDER,
        this.SHIP,
        this.JOHAN,
        this.TRADER,
        this.PRODUCT,
        this.TUTORIAL,
        this.CURRENCY,
        this.TRIGGER_GROUP,
        this.ITEM_GROUP,
        this.SMART_OFFER
    ];

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, TriggerKind.getValue(id));
        });
    }

    constructor(id = 0, name = "DEFAULT") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    equal(value) {
        if (value instanceof TriggerKind) {
            return this.id === value.id;
        } else if (Number.isInteger(value)) {
            return this.id === value;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TriggerKind());
        } else if (target instanceof TriggerKind) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(TriggerKind, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});